import {
  ApolloClient, ApolloLink, InMemoryCache, HttpLink,
} from 'apollo-boost';
import { Observable } from 'apollo-link';
import { BOLETOS_SERVICE_HOST } from '../lib/const';

const USE_BOLETO_MOCK_DATA = process.env.REACT_APP_USE_BOLETO_MOCK_DATA === 'true'

// Dados mockados para desenvolvimento
const mockData = {
  Boleto: {
    boleto: {
      __typename: 'Boleto',
      id: '123',
      pdfUrl: 'https://example.com/boleto.pdf',
      status: 'PAID',
      dueDate: '2024-12-31',
      formattedTypableLine: '34191.09008 00001.234567 89012.345678 9 87650000012345',
      logs: [],
    },
  },
};

const mockLink = new ApolloLink((operation, forward) => {
  if (!USE_BOLETO_MOCK_DATA) return forward(operation);

  if (mockData[operation.operationName]) {
    console.log(`[Apollo Mock] Retornando dados mockados para: ${operation.operationName}`);
    return new Observable((observer) => {
      observer.next({
        data: mockData[operation.operationName],
      });
      observer.complete();
    });
  }

  console.log(`[Apollo Mock] Nenhum mock encontrado para: ${operation.operationName}, encaminhando requisição`);
  return forward(operation);
});

const httpLink = new HttpLink({ uri: BOLETOS_SERVICE_HOST });

const authLink = new ApolloLink((operation, forward) => {
  // Retrieve the authorization token from local storage.
  const token = localStorage.getItem('boleto_token') || localStorage.getItem('token');

  // Use the setContext method to set the HTTP headers.
  operation.setContext({
    headers: { authorization: token ? `JWT ${token}` : '' },
  });

  // Call the next link in the middleware chain.
  return forward(operation);
});

const client = new ApolloClient({
  link: ApolloLink.from([
    mockLink,
    authLink,
    httpLink,
  ]),
  cache: new InMemoryCache(),
});

export default client;
